import request from '@/utils/request2'

// 获取会议室列表接口信息：

export function getMeetingRoomList(params) {
  return request({
    url: '/api/m1218/getMeetingRoomList',
    method: 'get',
    params: params
  })
}

// 获取当天所有会议室预定信息接口：

export function getMeetingBookDetail(params) {
  return request({
    url: '/api/m1218/getMeetingBookDetail',
    method: 'get',
    params: params
  })
}

export function getMeetingBookFieldStatus(params) {
  return request({
    url: '/api/m1218/getMeetingBookFieldStatus',
    method: 'get',
    params: params
  })
}

export function getBeforeActionList (data) {
  return request({
    url: '/api/baseform/getBeforeActionList',
    method: 'get',
    params: data
  })
}

export function processBeforeAction (data) {
  return request({
    url: '/api/baseform/processBeforeAction',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function postModuleRecord (data) {
  return request({
    url: '/api/curd/postModuleRecord',
    method: 'post',
    data
  })
}

export function processAfterAction (data) {
  return request({
    url: '/api/baseform/processAfterAction',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function getMeetingRoomAreaList (params) {
  return request({
    url: '/api/m1218/getMeetingRoomAreaList',
    method: 'get',
    params
  })
}
